import { createContext, useContext } from "react";
import type { User } from "firebase/auth";
import type { PropertyListing } from "@/data/listings";

export interface ListingsContextValue {
  listings: PropertyListing[];
  allListings: PropertyListing[];
  loading: boolean;
  storageMode: "firebase" | "local";
  error: string | null;
  session: User | null;
  isAdmin: boolean;
  signIn(email: string, password: string): Promise<void>;
  signOut(): Promise<void>;
  saveListing(listing: PropertyListing): Promise<void>;
  deleteListing(id: string): Promise<void>;
  uploadImages(files: File[]): Promise<string[]>;
}

export const ListingsContext = createContext<ListingsContextValue | null>(null);

export function useListings(): ListingsContextValue {
  const context = useContext(ListingsContext);
  if (!context) throw new Error("useListings, ListingsProvider içinde kullanılmalı.");
  return context;
}
